<template>
    <div  v-show="isPageFocused" v-bind:style="{left,top,width,height,background}" style="opacity:0.3; font-size: 36.6px; font-family: sans-serif;position:absolute">

    </div>

</template>

<script>
export default {
    props:{
        totalWidth: Number,
        totalHeight: Number,
        annotation: Object,
    },
    computed:{
        left(){
            return this.annotation.left*this.totalWidth+'px';
        },
        top(){
            return (this.annotation.top-this.annotation.page)*this.totalHeight+'px';
        },
        width(){
            return this.annotation.width*this.totalWidth+'px';
        },
        height(){
            return this.annotation.height*this.totalHeight+'px';
        },
        isPageFocused(){
            return this.annotation.page == this.$store.state.currentPage-1;
        },
        colors(){
            return this.$store.getters.colors;
        },
        background(){
            return this.colors[this.annotation.label];
        }
    }
}
</script>

<style>

</style>
